/* T0'BLACK — Entrada / selector de universos
   Ubicacion en Shopify: assets/t0black-entry.js (cargado con defer, solo en la Home).
   La clase html.t0-entry la agrega el <head> de theme.liquid si la entrada no se vio
   en esta sesion. Este script anima la entrada, deja la home inerte detras de la capa
   y la cierra cuando el usuario sigue bajando (scroll, swipe, teclado o indicador).
   Las cards son links normales: no se intercepta la navegacion. */
(function () {
  'use strict';

  var root = document.documentElement;
  var intro = document.querySelector('[data-t0-intro]');

  // Editor de temas: la seccion se muestra dentro del flujo, sin capa ni bloqueo.
  if (window.Shopify && window.Shopify.designMode) {
    root.classList.remove('t0-entry');
    return;
  }

  if (!root.classList.contains('t0-entry')) return;
  if (!intro) {
    root.classList.remove('t0-entry');
    return;
  }

  var SEEN_KEY = 't0black_intro_seen';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var logo = intro.querySelector('[data-t0-logo]');
  var text = intro.querySelector('[data-t0-text]');
  var cursor = intro.querySelector('[data-t0-cursor]');
  var indicator = intro.querySelector('[data-t0-indicator]');
  var useTypewriter = intro.getAttribute('data-typewriter') === 'true' && !reduce;
  var revealed = false;
  var inerted = [];

  try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}

  function remove(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  // Mientras la capa esta abierta, la home de atras no recibe foco ni clicks.
  function setBackgroundInert(on) {
    if (!on) {
      inerted.forEach(function (el) { el.removeAttribute('inert'); });
      inerted = [];
      return;
    }
    var host = intro.closest('.shopify-section') || intro;
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === host || el.contains(host) || el.hasAttribute('inert')) return;
      if (/^(SCRIPT|STYLE|LINK|NOSCRIPT|TEMPLATE)$/.test(el.tagName)) return;
      el.setAttribute('inert', '');
      inerted.push(el);
    });
  }

  function initProductReveal() {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var items = main.querySelectorAll('.grid__item, .card-wrapper, .collection-list__item');
    if (!items.length) return;

    Array.prototype.forEach.call(items, function (el) { el.classList.add('t0-fade'); });

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('t0-fade--in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.style.transitionDelay = (Number(el.getAttribute('data-t0-i')) % 4) * 80 + 'ms';
        el.classList.add('t0-fade--in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    Array.prototype.forEach.call(items, function (el, i) {
      el.setAttribute('data-t0-i', i);
      io.observe(el);
    });
  }

  // ---------- Cerrar la entrada y mostrar la home ----------
  function atBottom() {
    return intro.scrollTop + intro.clientHeight >= intro.scrollHeight - 2;
  }

  var touchStartY = null;
  var touchStartAtBottom = false;

  function onWheel(e) {
    if (e.deltaY > 0 && atBottom()) reveal();
  }
  function onTouchStart(e) {
    touchStartY = e.touches[0].clientY;
    touchStartAtBottom = atBottom();
  }
  function onTouchMove(e) {
    // Solo un swipe hacia arriba claro (no un tap sobre una card) y con la capa al final.
    if (touchStartY === null || !touchStartAtBottom) return;
    if (touchStartY - e.touches[0].clientY > 48) reveal();
  }
  function onKeyDown(e) {
    var k = e.key;
    if (k !== 'ArrowDown' && k !== 'PageDown' && k !== ' ' && k !== 'Spacebar') return;
    if ((k === ' ' || k === 'Spacebar') && e.target && e.target.closest && e.target.closest('a, button')) return;
    if (atBottom()) reveal();
  }

  function arm() {
    intro.addEventListener('wheel', onWheel, { passive: true });
    intro.addEventListener('touchstart', onTouchStart, { passive: true });
    intro.addEventListener('touchmove', onTouchMove, { passive: true });
    window.addEventListener('keydown', onKeyDown);
    if (indicator) indicator.addEventListener('click', reveal);
  }
  function disarm() {
    intro.removeEventListener('wheel', onWheel);
    intro.removeEventListener('touchstart', onTouchStart);
    intro.removeEventListener('touchmove', onTouchMove);
    window.removeEventListener('keydown', onKeyDown);
    if (indicator) indicator.removeEventListener('click', reveal);
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    disarm();
    setBackgroundInert(false);
    intro.classList.add('is-hidden');
    root.classList.remove('t0-entry');
    root.classList.add('t0-revealing');
    window.setTimeout(function () {
      root.classList.remove('t0-revealing');
      remove(intro);
    }, 950);
    initProductReveal();
  }

  // ---------- Slogan ----------
  function fillText() {
    if (text) text.textContent = text.getAttribute('data-text') || '';
    remove(cursor);
  }

  function typewriter() {
    if (!text) return;
    var str = text.getAttribute('data-text') || '';
    var i = 0;
    if (cursor) cursor.classList.add('is-on');
    (function tick() {
      text.textContent = str.slice(0, i);
      i++;
      if (i <= str.length) {
        window.setTimeout(tick, 26 + Math.random() * 20);
      } else if (cursor) {
        cursor.classList.add('is-off');
      }
    })();
  }

  // Volver con el boton "atras" a una home ya revelada (bfcache): sin capa.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && revealed) {
      root.classList.remove('t0-entry', 't0-revealing');
      remove(intro);
    }
  });

  setBackgroundInert(true);
  arm();

  try {
    if (logo) {
      if (reduce) {
        logo.classList.add('is-focused');
      } else {
        requestAnimationFrame(function () { logo.classList.add('is-focused'); });
      }
    }
    if (useTypewriter) {
      window.setTimeout(typewriter, 900);
    } else {
      fillText();
    }
  } catch (err) {
    // La animacion es decorativa: ante un error se muestra el texto completo y
    // las cards siguen funcionando.
    if (logo) logo.classList.add('is-focused');
    fillText();
  }
})();
